

  export default function parseAnswerAttached(response, userData) {

    let { data, included = [] } = response;
    
    return data.map(applicant => {

      let cvId = applicant.relationships.field_cv?.data?.id;
      let profileId = applicant.relationships.field_profile?.data?.id;
      let lorFileId = applicant.relationships.field_lor_file?.data?.id
      let personalStatementId = applicant.relationships.field_res_personal?.data?.id;
      let lorChairId = applicant.relationships.field_lor_chair?.data?.id;
      let meritId = applicant.relationships.field_merit?.data?.id;

      let userId = applicant.relationships.uid?.data?.id;

      let cv = included.filter(cv => cv.type == 'file--file').find(cv => cv.id === cvId) || {};
      let profile = included.filter(profile => profile.type == 'file--file').find(profile => profile.id === profileId) || {};
      let lorFile = included.filter(lorFile => lorFile.type == 'file--file').find(lorFile => lorFile.id === lorFileId) || {};
      let personalStatement = included.filter(ps => ps.type == 'file--file').find(ps => ps.id === personalStatementId) || {};
      let lorChair = included.filter(lor => lor.type == 'file--file').find(lor => lor.id === lorChairId) || {};
      let merit = included.filter(merit => merit.type == 'file--file').find(merit => merit.id === meritId) || {};

      let lors = included.filter(lor => lor.type == 'node--lor_request' && lor.relationships.field_letter.data && lor.relationships.uid?.data?.id === userId) || [];

      return {
        ...applicant,
        attributes : {
          ...applicant.attributes,
          field_cv : {
            ...applicant.relationships?.field_cv,
            ...cv
          },
          field_profile : {
            ...applicant.relationships?.field_profile,
            ...profile
          },
          field_lor_file : {
            ...applicant.relationships?.field_lor_file,
            ...lorFile
          },
          field_res_personal : {
            ...applicant.relationships?.field_res_personal,
            ...personalStatement
          },
          field_lor_chair : {
            ...applicant.relationships?.field_lor_chair,
            ...lorChair
          },
          field_merit : {
            ...applicant.relationships?.field_merit,
            ...merit
          },
          field_letters_of_recommendation: lors
        }
      }
    })
  }